import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'lib-rc-input',
  template: `<div class="form-group rc-form-input" [ngClass]="{'no-description': !description}">
  <div class="title-placeholder">
    <label *ngIf="placeholder" class="input-label-with-placeholder" [for]="elementId">{{label}}</label>
    <input
      autocomplete="{{autocomplete}}"
      type="{{type}}"
      id="{{elementId}}"
      class="form-control"
      [ngClass]="{'have-value' : control.value}"
      maxlength="{{maxlength}}"
      [formControl]="control"
      value="{{control.value}}"
      attr.aria-label="{{ariaLabel}}"
      attr.aria-describedby="{{getAriaDescribedBy()}}"
      (focus)="onFocus()"
      [attr.placeholder]="placeholder"
      (blur)="onBlur($event)"
      (keyup)="onKeyUp($event)"
      (keydown)="onKeydown($event)"
      [attr.disabled]="_disabled== true ? true : null">

    <label *ngIf="!placeholder" class="input-label" [for]="elementId">{{label}}</label>
    <button class="show-password" *ngIf="(control.value && control.value.length) && showPasswordEye" role="button" tabindex="0"
            attr.aria-label="{{getPasswordLabel()}}"
            (mousedown)="showPassword()"
            (mouseup)="hidePassword()"
            (mouseout)="hidePassword()"
            (keydown)="handleEnter($event)"
            (blur)="hidePassword()"
    ></button>

    <div role="alert" aria-live="polite" id="{{errorElementId}}" class="invalid-feedback-message" *ngIf="errorMsg">{{ errorMsg }}</div>
  </div>
</div>

`,
  styles: [`.rc-form-input{margin-top:20px;margin-bottom:20px;position:relative;transition:.3s}.rc-form-input label.input-label{position:absolute;left:12px;top:7px;transition:.3s}.rc-form-input label.input-label-with-placeholder{margin-left:12px;margin-bottom:5px}.rc-form-input .form-control.have-value+label{top:-25px;font-size:16px}.rc-form-input .form-control:focus+label{top:-25px;display:block;font-size:16px}.rc-form-input .show-password{position:absolute;top:10px;background-repeat:no-repeat;cursor:pointer;border:none;background-color:transparent}`]
})


/**
 * to see the password eye you must add you icon .show-password to your css
 * and add its position - right/left
 * example
 * .show-password {
    height: 17px;
    width: 23px;
    right: 5px;
    background-image: url(/assets/images/password_eye.svg);
  }
 */

export class RcInputComponent extends RcFormControlAbstract implements OnInit {

  @Input() type: string = 'text';
  @Input() maxlength: number;
  @Input() autocomplete: string = 'off';
  @Input() label: string;
  @Input() description: string;
  @Input() placeholder = null;
  @Input() allowNegatives: boolean = true;
  @Input() allowDecimals: boolean = true;
  @Input() allowPlus: boolean = false;
  @Input() showPasswordEye: boolean = false;
  @Input() passwordLabelMessage: string = '';

  @Output() keyDownCallback: EventEmitter<any> = new EventEmitter();

  public onKeydown($event) {
    if (this.keyDownCallback.observers.length) {
      this.keyDownCallback.emit($event);
    }
    if ($event.key === '+' && !this.allowPlus) {
      $event.preventDefault();
    }

    if (($event.key === '-' || $event.key === 'Subtract')) {
      if (!this.allowNegatives && this.type === 'number') {
        $event.preventDefault();
      }
    }

    if ($event.key === '.') {
      if (!this.allowDecimals && this.type === 'number') {
        $event.preventDefault();
      }
    }
  }

  public onKeyUp($event) {
    const str = this.control.value ? this.control.value.toString() : this.control.value;

    if (!str && ($event.key === '-' || $event.key === 'Subtract')) {
      return;
    }

    if (!this.allowNegatives && this.type === 'number') {
      if (parseFloat(this.control.value) < 0) {
        this.control.setValue(null);
      }
    }
    if (!this.allowDecimals && this.type === 'number') {

      const isDecimal = this.control.value ? this.control.value.match(/^(0|[1-9]\d*)$/) : null;

      if (isDecimal === null) {
        this.control.setValue(null);
      }
    }
    if (str && this.type === 'number') {
      const valueOnlyNumberChars = str
          .replace(new RegExp("[-]+$"), "")
          .replace(/[^-0-9,.]+/g, '')
          .replace('--', '-');
      this.control.setValue(valueOnlyNumberChars);
    }

    if (!isNullOrUndefined(this.maxlength) && this.maxlength > 0 && str && str.length > this.maxlength) {
      this.control.setValue(str.substring(0, this.maxlength));
    }
    super.onChange($event);
  }

  getPasswordLabel() {
    if (this.type === 'text') {
      return this.control.value;
    } else {
      return this.passwordLabelMessage;
    }
  }

  showPassword() {
    this.type = 'text';
  }


  hidePassword() {
    this.type = 'password';
    this.getPasswordLabel();
  }

  handleEnter($event) {
    if ($event.which === 13) {
      if (this.type === 'password') {
        this.showPassword();
      } else {
        this.hidePassword();
      }
    }
  }
}
